import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'itl-listitem-additional-info',
  template: '<ng-content></ng-content>',
  styles: [':host {margin-top: 10px;}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ListitemAdditionalInfoComponent {}
